"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Separator } from "@/components/ui/separator";
import { Twitter, Linkedin, Github, ArrowUpRight } from "lucide-react";
const regionalLinks = [{
  label: "Term Life",
  to: "/HomePage"
}, {
  label: "Whole Life",
  to: "/HomePage"
}, {
  label: "Final Expense",
  to: "/HomePage"
}];
const companyLinks = [{
  label: "Our Mission",
  to: "/HomePage"
}, {
  label: "Privacy Policy",
  to: "/HomePage"
}, {
  label: "Contact Agent",
  to: "/HomePage"
}];
const socialLinks = [{
  icon: Twitter,
  to: "#",
  label: "Twitter"
}, {
  icon: Linkedin,
  to: "#",
  label: "LinkedIn"
}, {
  icon: Github,
  to: "#",
  label: "GitHub"
}];
const tickerItems = ["LICENSED IN 50 STATES", "A+ RATED CARRIERS", "SECURE DATA ENCRYPTION", "PERSONALIZED COVERAGE", "FAMILY PROTECTION FIRST", "FINANCIAL SECURITY", "ESTATE PLANNING", "PEACE OF MIND", "TRUSTED ADVISORY", "LEGACY PRESERVATION"];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="264915" id="footer" className="bg-background text-foreground pt-16 overflow-hidden flex flex-col">
      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-ticker {
          animation: ticker 40s linear infinite;
          display: flex;
          width: max-content;
        }
        .animate-ticker:hover {
          animation-play-state: paused;
        }
      `}</style>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 mb-16 flex-grow">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-foreground" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs mb-6 font-default">
              Providing sophisticated life insurance solutions with a focus on simplicity, trust, and the long-term security of your family's legacy.
            </p>
            <p className="text-muted-foreground text-xs mt-auto font-default opacity-70">
              © {currentYear} LIFECOVER. All rights reserved.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 tracking-tight text-foreground">Solutions</h3>
            <ul className="space-y-4">
              {regionalLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.to} className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center group font-default">
                    {link.label}
                    <ArrowUpRight className="ml-1 size-3 opacity-0 -translate-y-1 translate-x-1 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all duration-300" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 tracking-tight text-foreground">Resources</h3>
            <ul className="space-y-4">
              {companyLinks.map((link, i) => <li key={i} data-index={i}>
                  <Link to={link.to} className="text-muted-foreground hover:text-primary transition-colors text-sm flex items-center group font-default">
                    {link.label}
                    <ArrowUpRight className="ml-1 size-3 opacity-0 -translate-y-1 translate-x-1 group-hover:opacity-100 group-hover:translate-y-0 group-hover:translate-x-0 transition-all duration-300" />
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 tracking-tight text-foreground">Connect</h3>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} data-index={i} to={social.to} aria-label={social.label} className="bg-muted hover:bg-primary hover:text-primary-foreground text-foreground p-2.5 rounded-md transition-all duration-300 shadow-sm">
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>
      </div>

      {}
      <Separator className="w-full bg-border/30" />

      {}
      <div className="w-full overflow-hidden bg-background py-4">
        <div className="animate-ticker flex items-center">
          {}
          {[...tickerItems, ...tickerItems].map((item, i) => <div key={i} data-index={i} className="flex items-center shrink-0">
              <span className="font-mono text-[10px] tracking-widest text-muted-foreground/60 whitespace-nowrap uppercase px-4">
                {item}
              </span>
              <span className="text-border/30 text-[10px]">|</span>
            </div>)}
        </div>
      </div>
      
      {}
      <div className="container mx-auto px-4 md:px-6 lg:px-8 py-6">
        <p className="text-[10px] text-muted-foreground/50 leading-tight text-center font-default">
          LIFECOVER is a licensed insurance agency. All insurance products are subject to the terms and conditions of the issuing insurance company. Coverage may not be available in all jurisdictions. This website provides a summary of coverage and does not constitute a contract. Please consult with a licensed agent for specific licensing information in your state of residence.
        </p>
      </div>
    </section>;
}